<template lang="pug">
  <div class="es-home es-page">
    .es-inner.es-inner_widget
      //- Banner slider
      BannerSlider
      .widget-wrapper
        div(class="widget" data-widgetid="EXPRESODELSOL" style="position: relative; width: 80%; margin:auto; ")
    .es-inner
      //- Featured slider
      FeaturedSlider
      //- Grid duo mapa
    .es-inner
      .es-grid-duo
        .es-grid-duo__item.es-grid-duo__item_content
          h2.es-subtitle Consulta nuestros destinos y horarios aquí
          p.es-txt Te contamos cuales son todos nuestros destinos, horarios y servicios; nos ajustamos a tus necesidades de viaje y te llevamos seguro a tu destino.
          .es-grid-duo__btn-wrap
            nav.es-nav-actions
              router-link.es-btn.es-btn_secondary(to="/rutas") Conoce todas nuestras rutas
              a.es-btn.es-btn_primary.es-btn_redbus(href="https://www.redbus.co/viajes/pasajes-de-bus-expreso-del-sol" target="_blank") Compra aquí tus pasajes
        .es-grid-duo__item.es-grid-duo__item_img
          router-link(to="/rutas")
            img.es-slider-futured__img(src="../assets/img/mapa-home-min.jpg")
    .es-inner
      .es-grid-duo.es-grid-duo_right
        .es-grid-duo__item.es-grid-duo__item_img
          img.es-slider-futured__img(src="../assets/img/nosotros-home-min.jpg")
        .es-grid-duo__item.es-grid-duo__item_content
          h2.es-subtitle Sobre nosotros
          p.es-txt Somos una empresa de transporte intermunicipal de pasajeros por carretera con un radio de acción nacional, que cuenta con personal eficiente y con gran calidad humana, además de una flota de vehículos en constante renovación para garantizar tu seguridad y confort; nos enfocamos en la capacitación constante de nuestros operarios y la inspección diaria de nuestra flota, con el fin de asegurarnos que el viaje que realizas sea de tu total agrado y que por ello decidas siempre contar con nosotros.
          .es-grid-duo__btn-wrap
            router-link.es-btn.es-btn_primary(to="/nosotros") Conoce más sobre nosotros
    .es-inner
      section.es-section.es-allied
        header.es-subheader
          h2.es-subtitle Somos tu mejor aliado
        ComfortListHome
    .es-inner
      section.es-section
        h2.es-subtitle Contáctanos
        p.es-txt El área de atención al usuario de Expreso del Sol S.A.S. esta encargada de definir modelos específicos para atender, manejar y dar soluciones contundentes a las inquietudes, quejas y sugerencias que puedan generarse durante tu experiencia como usuario o antes de ella.
        nav.es-nav-actions
          router-link.es-btn.es-btn_secondary(to="/contacto") Ir a página de contácto
          a.es-btn.es-btn_primary.es-btn_redbus(href="https://www.redbus.co/viajes/pasajes-de-bus-expreso-del-sol" target="_blank") Compra aquí tus pasajes

  </div>
</template>

<script>
// @ is an alias to /src
import BannerSlider from "@/components/BannerSlider.vue";
import FeaturedSlider from "@/components/FeaturedSlider.vue";
import ComfortListHome from "@/components/ComfortListHome.vue";

export default {
  name: "Home",
  components: {
    BannerSlider,
    FeaturedSlider,
    ComfortListHome,
  },
};
</script>
